import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NavbarService } from 'src/app/services/navbar/navbar.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-version',
    templateUrl: './app-version.component.html',
    styleUrls: ['./app-version.component.scss'],
})
export class AppVersionComponent implements OnInit {
    private static readonly CLICKS_TO_ENABLE_DEV_MODE = 5;

    devCounter = 0;
    version: string;

    constructor(
        private navbarService: NavbarService,
        private notification: NzNotificationService
    ) {
        this.version = environment.version;
    }

    ngOnInit() {}

    /**
     * Count clicks on the version label and enable developer mode on the 5th one.
     *
     * Once enabled, further clicks are ignored — dev mode is sticky for the session and only
     * a page reload turns it off. On activation a celebratory auto-dismiss notification is
     * shown.
     */
    public toggleDeveloperMode(): void {
        if (this.navbarService.showDevDashboards) {
            return;
        }

        this.devCounter++;
        if (this.devCounter >= AppVersionComponent.CLICKS_TO_ENABLE_DEV_MODE) {
            this.navbarService.enableDeveloperMode();
            this.notification.success('Gratulacje, zostałeś developerem!', '');
        }
    }
}
